function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import IconButton from '../icon-button';
import HiddenInput from '../input/hidden/style';
export default class Checkbox extends React.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      checked: this.props.checked || false
    });

    _defineProperty(this, "handleClickEvent", () => {
      if (this.props.onClick) {
        this.setState(state => ({
          checked: !state.checked
        }), () => {
          this.props.onClick && this.props.onClick(this.state.checked);
        });
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.checked !== this.props.checked) {
      this.setState({
        checked: !!this.props.checked
      });
    }
  }

  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
      className: this.props.className,
      onClick: this.handleClickEvent,
      size: this.props.size,
      disabled: this.props.disabled,
      icon: this.state.checked ? 'Checked' : 'Checkbox'
    }), /*#__PURE__*/React.createElement(HiddenInput, {
      checked: this.state.checked,
      onChange: () => {
        /* This empty onChange is necessary to avoid warnings. */
      },
      type: 'checkbox'
    }));
  }

}